import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { httpInterceptorInterceptor } from "./core/interceptor/http-interceptor.interceptor";
import { LoadingBarHttpClientModule } from "@ngx-loading-bar/http-client";

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withInterceptors([httpInterceptorInterceptor])),
    importProvidersFrom(LoadingBarHttpClientModule)
  ]
};
